<template>
  <div class="con">
    <div class="section" v-for="(item, index) in value" v-bind:key="index">
      <FormItem :label="$t('appointment.visitors.name')">
        <Input type="text" v-model="item.name" :placeholder="$t('visitor.apply.name.tips')" />
        <span @click="remove(index)" class="remove" v-if="value.length > 1">{{
          $t('visitor.apply.addon.add.remove')
        }}</span>
      </FormItem>
      <FormItem :label="$t('appointment.visitors.image')">
        <Upload v-model="item.photo" />
      </FormItem>

      <FormItem :label="$t('appointment.visitors.phone')">
        <Input type="text" v-model="item.tel" :placeholder="$t('appointment.visitors.phone.tips')" />
      </FormItem>
      <FormItem :label="$t('appointment.visitors.card.type')" arr="true">
        <BottomObjSelect
          :columns="cardTypes"
          :value.sync="item.certificatesType"
          :placeholder="$t('appointment.visitors.card.type.tips')"
        />
      </FormItem>
      <FormItem :label="$t('appointment.visitors.idnumber')">
        <Input v-model="item.certificatesNumber" :placeholder="$t('appointment.visitors.idnumber.tips')" />
      </FormItem>
      <FormItem :label="$t('appointment.visitors.social.security.certificate.files')">
        <div class="upload-files-item">
          <UploadFile :isOa="true" :name="item.name" v-model="item.socialSecurityFile" :isDelete="true" />
          <div class="context">{{ $t('appointment.visitors.social.security.certificate.files.tip') }}</div>
        </div>
      </FormItem>
    </div>

    <div class="add">
      <span @click="onAdd">{{ $t('visitor.apply.addon.add') }}</span>
    </div>
  </div>
</template>

<script>
import FormItem from '@/components/formItem.vue';
import Input from '@/components/input.vue';
import Upload from '@/components/visitorUpload.vue';
import { Notify } from 'vant';
import BottomObjSelect from '@/components/bottomObjSelect.vue';
import UploadFile from '@/components/uploadFile.vue';

export default {
  components: { FormItem, BottomObjSelect, Upload, Input, UploadFile },
  data() {
    return {
      cardTypes: [
        { id: 1, text: this.$t('appointment.visitors.idcard') },
        { id: 2, text: this.$t('appointment.visitors.permit') },
        { id: 3, text: this.$t('appointment.visitors.passport') },
      ],
    };
  },
  props: ['value', 'type'],
  watch: {},
  methods: {
    // beforeUpload(item) {
    //   console.log('item', item);
    //   if (!item) {
    //     Notify({
    //       type: 'warning',
    //       message: this.$t('appointment.visitors.social.security.certificate.files。before'),
    //     });
    //     return false;
    //   }
    // },
    onConfirm(value) {
      this.$emit('update:value', value);
    },
    valid() {
      return this.value.map(i => {
        if (!i.name) {
          Notify({
            type: 'warning',
            message: this.$t('appointment.visitors.name.tips'),
          });
          return false;
        }
        if (!i.photo) {
          Notify({
            type: 'warning',
            message: this.$t('appointment.visitors.image.tips'),
          });
          return false;
        }
        if (!i.tel) {
          Notify({
            type: 'warning',
            message: this.$t('appointment.visitors.phone.tips'),
          });
          return false;
        }
        if (i.tel) {
          const reg = /^1[3-9]\d{9}$/;
          if (!reg.test(i.tel)) {
            Notify({
              type: 'warning',
              message: this.$t('visitor.apply.phone.error.tips'),
            });
            return false;
          }
        }
        if (!i.certificatesType) {
          Notify({
            type: 'warning',
            message: this.$t('appointment.visitors.card.type.tips'),
          });
          return false;
        }
        if (!i.certificatesNumber) {
          Notify({
            type: 'warning',
            message: this.$t('appointment.visitors.idnumber.tips'),
          });
          return false;
        }

        if (i.certificatesNumber && i.certificatesType) {
          const regIdCard = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
          // const regPermit = /^8[123]0000(?:19|20)\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])\d{3}[\dX]$/;
          // const regPassport = /^([a-zA-z]|[0-9]){5,17}$/;

          if (i.certificatesType === 1 && !regIdCard.test(i.certificatesNumber)) {
            Notify({
              type: 'warning',
              message: this.$t('appointment.visitors.idcard.tips'),
            });
            return false;
          }
          // if (i.certificatesType === 2 && !regPermit.test(i.certificatesNumber)) {
          //   Notify({
          //     type: 'warning',
          //     message: this.$t('appointment.visitors.permit.tips'),
          //   });
          //   return false;
          // }
          // if (i.certificatesType === 3 && !regPassport.test(i.certificatesNumber)) {
          //   Notify({
          //     type: 'warning',
          //     message: this.$t('appointment.visitors.passport.tips'),
          //   });
          //   return false;
          // }
        }
        if (!i.socialSecurityFile || !i.socialSecurityFile.length) {
          Notify({
            type: 'warning',
            message: this.$t('appointment.visitors.social.security.certificate.files.tip'),
          });
          return false;
        }
        return true;
      });
    },

    onAdd() {
      const index = this.valid().findIndex(i => i === false);

      if (index === -1) {
        const value = this.value;
        value.push({
          name: '',
          photo: '',
          tel: '',
          certificatesType: '',
          certificatesNumber: '',
          socialSecurityFile: '',
        });
        this.$emit('update:value', value);
      }
    },
    remove(index) {
      const value = this.value.splice(index, 1);
      this.$emit('update:value', value);
    },
  },
  created() {},
};
</script>

<style lang="less" scoped>
.con {
  .section {
    margin-top: 20px;
    .upload-files-item {
      padding-bottom: 10px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .context {
        font-size: 30px;
        color: #949aa4;
        text-align: left;
      }
    }
    .remove {
      font-size: 28px;
      color: #fd5e72;
      display: inline-block;
      padding: 30px;
      white-space: nowrap;
    }
  }
  .add {
    font-size: 30px;
    color: #00ccbf;
    text-align: right;
    padding: 20px 30px;
  }
}
</style>
